import React, { useEffect, useState } from "react";
import * as api from "../../common/athleteCommon/API";
import * as func from "../../common/athleteCommon/FunctionCalls";
import { all_routes } from '../../router/all_routes';
import Utils from "../../common/athleteCommon/Utils";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import MedicalHistory from "./MedicalHistory";
import InjuryHistory from "./InjuryHistory";
import SurgeryHistory from "./SurgeryHistory";
import PhysiologicalHistory from "./PhysiologicalHistory";
import Cropper, { Area } from "react-easy-crop";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";

const Profile = () => {

    const routes = all_routes;
    const navigate = useNavigate();
    const [oldPwd, setOldPwd] = useState('');
    const [newPwd, setNewPwd] = useState('');
    const [cnfmNwPwd, setCnfmNwPwd] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [pwdError, setPwdError] = useState('');
    const [profileDetails, setProfileDetails] = useState<any[]>([]);
    const [medicalHistory, setMedicalHistory] = useState<any[]>([]);
    const [injuryHistory, setInjuryHistory] = useState<any[]>([]);
    const [surgeryHistory, setSurgeryHistory] = useState<any[]>([]);
    const [physiologicalHistory, setPhysiologicalHistory] = useState<any[]>([]);
    const [imagePreview, setImagePreview] = useState<string | null>(api.parentAPI2 + (localStorage.getItem("profilePic")));
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("Medical History");
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area | null>(null);

    const UsrName = localStorage.getItem('UserName');

    useEffect(() => {
        async function fetchDetails() {
            setIsLoading(true);
            const profileResponse = await func.athleteProfile();

            setProfileDetails(profileResponse?.athleteProfile || {})
            setMedicalHistory(profileResponse?.medicalHistory || {})
            setInjuryHistory(profileResponse?.injuryHistory || {})
            setSurgeryHistory(profileResponse?.surgeryHistory || {})
            setPhysiologicalHistory(profileResponse?.physiologicalHistory || {})

            setIsLoading(false);
        }
        fetchDetails();
    }, [])

    const tabData = [
        {
            icon: <i className="fas fa-user" />,
            name: "Medical History",
            content: <MedicalHistory history={medicalHistory} />
        },
        {
            icon: <i className="fas fa-id-card" />,
            name: "Injury History",
            content: <InjuryHistory history={injuryHistory} />
        },
        {
            icon: <i className="fas fa-futbol" />,
            name: "Surgery History",
            content: <SurgeryHistory history={surgeryHistory} />
        },
        {
            icon: <i className="fas fa-futbol" />,
            name: "Physiological History",
            content: <PhysiologicalHistory history={physiologicalHistory} />
        },
    ]

    // function changePwd() {
    //     if (!pwdError) {

    //         const formData = new FormData();
    //         formData.append('oldPassword', oldPwd)
    //         formData.append('newPassword', newPwd)

    //         const changePassWord = api.TenvicChangePassword;
    //         fetch(changePassWord, {
    //             method: "POST",
    //             headers: {
    //                 "Authorization": 'Bearer ' + Utils.getAccessToken()
    //             },
    //             body: formData
    //         })
    //             .then((response) => response.json())
    //             .then((result) => {
    //                 if (result.error == false) {
    //                     Swal.fire(result.message)
    //                     setOpenModal(false)
    //                     navigate("/tenviclogin");
    //                 } else {
    //                     setPwdError(result.message)
    //                 }
    //                 if (result.error == false) {
    //                     Swal.fire({
    //                         title: 'Success',
    //                         text: result.message,
    //                         icon: 'success',
    //                         confirmButtonText: 'OK',
    //                         allowOutsideClick: false,
    //                         allowEscapeKey: false
    //                     }).then((res) => {
    //                         if (res.isConfirmed) {
    //                             // window.location.reload(); // 🔁 Reload only after OK is clicked
    //                             setOpenModal(false)
    //                             navigate(routes.tenviclogin)
    //                         }
    //                     });
    //                 } else {
    //                     setPwdError(result.message)
    //                 }
    //             })
    //     }
    // }

    const handleImageSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];

        if (!file) return;

        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "image/svg+xml"
        ];

        if (!allowedTypes.includes(file.type)) {
            Swal.fire("Please upload JPG, PNG or SVG image.");
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            Swal.fire("Image size must be less than 5MB.");
            return;
        }

        const imageUrl = URL.createObjectURL(file);

        // Show selected image in cropper
        setSelectedImage(imageUrl);

        // Reset crop position and zoom
        setCrop({ x: 0, y: 0 });
        setZoom(1);

        // Reset previous crop
        setCroppedAreaPixels(null);
    };

    const onCropComplete = (
        croppedArea: Area,
        croppedAreaPixels: Area
    ) => {
        setCroppedAreaPixels(croppedAreaPixels);
    };

    const getCroppedImg = async (
        imageSrc: string,
        cropArea: Area
    ): Promise<Blob> => {
        const image = new Image();

        image.src = imageSrc;

        await new Promise<void>((resolve, reject) => {
            image.onload = () => resolve();
            image.onerror = reject;
        });

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        if (!ctx) {
            throw new Error("Unable to create canvas context");
        }

        canvas.width = cropArea.width;
        canvas.height = cropArea.height;

        ctx.drawImage(
            image,
            cropArea.x,
            cropArea.y,
            cropArea.width,
            cropArea.height,
            0,
            0,
            cropArea.width,
            cropArea.height
        );

        return new Promise<Blob>((resolve, reject) => {
            canvas.toBlob(
                (blob) => {
                    if (blob) {
                        resolve(blob);
                    } else {
                        reject(new Error("Unable to create image"));
                    }
                },
                "image/jpeg",
                0.9
            );
        });
    };

    const handleCropSave = async () => {
        if (!selectedImage || !croppedAreaPixels) {
            Swal.fire(
                "Please select and adjust an image before saving.",
                "",
                "warning"
            );
            return;
        }

        try {
            // Create cropped image
            const croppedBlob = await getCroppedImg(
                selectedImage,
                croppedAreaPixels
            );

            // Show cropped image immediately
            const croppedUrl = URL.createObjectURL(croppedBlob);
            setImagePreview(croppedUrl);

            // Prepare API request
            const formData = new FormData();

            formData.append(
                "profileImage",
                croppedBlob,
                "profile-image.jpg"
            );

            const response = await fetch(api.UploadImage, {
                method: "POST",
                headers: {
                    Authorization: "Bearer " + Utils.getAccessToken()
                },
                body: formData
            });

            const result = await response.json();

            // console.log("Upload result:", result);

            if (result.status === "success") {

                localStorage.setItem(
                    "profilePic",
                    result.data.profileImage
                );

                // Remove cropper after successful upload
                setSelectedImage(null);

                Swal.fire({
                    title: "Success",
                    text: result.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then((res) => {
                    if (res.isConfirmed) {
                        window.location.reload();
                    }
                });

            } else {

                if (result.code === 401) {
                    Utils.logoutUser();
                    return;
                }

                Swal.fire(
                    "Error",
                    result.message,
                    "error"
                );
            }

        } catch (error) {

            console.error(
                "Error cropping/uploading image:",
                error
            );

            Swal.fire(
                "Error",
                "Unable to process the image.",
                "error"
            );
        }
    };

    const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];

        if (!file) return;

        // Optional: validate file type
        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "image/svg+xml"
        ];

        if (!allowedTypes.includes(file.type)) {
            Swal.fire("Please upload JPG, PNG or SVG image.");
            return;
        }

        const previewUrl = URL.createObjectURL(file);
        setImagePreview(previewUrl);

        if (file.size > 5 * 1024 * 1024) {
            Swal.fire("Image size must be less than 5MB.");
            return;
        }

        // Optional: validate minimum dimensions
        // This can be added separately if you need to enforce 150x150.

        try {
            const formData = new FormData();

            formData.append("profileImage", file);

            // Call your API
            const imgUpload = api.UploadImage;
            fetch(imgUpload, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    console.log(result);

                    if (result.status == "success") {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                localStorage.setItem("profilePic", result.data.profileImage)
                                // window.location.reload(); // 🔁 Reload only after OK is clicked
                                // navigate(routes.manipurlogin)
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        setPwdError(result.message)
                    }
                })
        } catch (error) {
            console.error("Error uploading image:", error);
        }
    };

    const validatePasswords = (pwd, confirmPwd) => {
        if (pwd && confirmPwd && pwd !== confirmPwd) {
            setPwdError("Passwords do not match!");
        } else {
            setPwdError("");
        }
    };
    return (
        <>
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items">
                                <div className="col-lg-6">
                                    <h4 className="mb-40">Profile</h4>
                                </div>
                                {/* <div className="col-lg-6 text-end">
                                    <Button
                                        className="btn-secondary me-3 text-uppercase"
                                        variant="success"
                                        onClick={() => setOpenModal(true)}
                                    >
                                        <i className="fas fa-key" />&nbsp;
                                        Change Password
                                    </Button>
                                </div> */}
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="court-tab-content">
                                        <div className="card card-tableset mb-2">
                                            <div className="card-body" style={{ overflowY: "scroll", overflowX: "hidden" }}>
                                                <div className="row">
                                                    <div className="col-lg-9">
                                                        <div className="coache-head-blk">

                                                            {/* <div className="row align-items-center" style={{ maxHeight: "140px", overflowY: "scroll" }}> */}

                                                            <div className="card court-information">
                                                                <div className="card dashboard-card court-information">

                                                                    {/* {profileDetails && Object.entries(profileDetails).length > 0 && (
                                                            Object.entries(profileDetails).map(([key, value]) => (
                                                                <div key={key} className="col-lg-3 col-md-4 col-sm-6 mb-3">
                                                                    <h4 className="me-2">{key}:</h4>
                                                                    <strong>{value ?? "N/A"}</strong>
                                                                </div>
                                                            ))
                                                        )} */}
                                                                    {/* <table>
                                                                    <tr>
                                                                        <th><h4 className="text-center">Name:</h4></th>
                                                                        <td><h6>{profileDetails.athleteName}</h6></td>
                                                                        <th><h4 className="text-center">User Email:</h4></th>
                                                                        <td><h6>{profileDetails.userEmail}</h6></td>
                                                                        <th><h4 className="text-center">User Phone:</h4></th>
                                                                        <td><h6>{profileDetails.userPhone}</h6></td>
                                                                        <th><h4 className="text-center">Role Name:</h4></th>
                                                                        <td><h6>{profileDetails.roleName}</h6></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th><h4 className="text-center">Sport Name:</h4></th>
                                                                        <td><h6>{profileDetails.sportsName}</h6></td>
                                                                        <th><h4 className="text-center">Coach Name:</h4></th>
                                                                        <td><h6>{profileDetails.coachName}</h6></td>
                                                                        <th><h4 className="text-center">State Name:</h4></th>
                                                                        <td><h6>{profileDetails.geographyName}</h6></td>
                                                                        <th><h4 className="text-center">District Name:</h4></th>
                                                                        <td><h6>{profileDetails.geoDistrictsName}</h6></td>
                                                                    </tr>
                                                                    <tr><th><h4 className="text-center">City Name:</h4></th>
                                                                        <td><h6>{profileDetails.geoCityName}</h6></td>
                                                                        <th><h4 className="text-center">Center Name:</h4></th>
                                                                        <td><h6>{profileDetails.geoCenterName}</h6></td>
                                                                        <th><h4 className="text-center">Athelete Onboard Status Name:</h4></th>
                                                                        <td><h6>{profileDetails.athleteOnboardStatusName}</h6></td>
                                                                        <th><h4 className="text-center">Status:</h4></th>
                                                                        <td><h6>{(profileDetails.userStatus == 1) ? "Active" : "Inactive"}</h6></td>
                                                                    </tr>
                                                                </table> */}

                                                                    <div className="appointment-info appoin-border double-row">
                                                                        <ul className="appointmentset">
                                                                            <li>
                                                                                <h6>Name</h6>
                                                                                <p>{profileDetails.athleteName}</p>
                                                                            </li>
                                                                            <li>
                                                                                <h6>User Email:</h6>
                                                                                <p>{profileDetails.userEmail}</p>
                                                                            </li>
                                                                            <li>
                                                                                <h6>User Phone:</h6>
                                                                                <p>{profileDetails.userPhone}</p>
                                                                            </li>
                                                                            <li>
                                                                                <h6>Role Name:</h6>
                                                                                <p>{profileDetails.roleName}</p>
                                                                            </li>
                                                                        </ul>
                                                                        </div>
                      <div className="appointment-info appoin-border double-row">
                                                                        <ul className="appointmentset">
                                                                            <li>
                                                                                <h6>Sport Name:</h6>
                                                                                <p>{profileDetails.sportsName}</p>
                                                                            </li>
                                                                            <li>
                                                                                <h6>Coach Name:</h6>
                                                                                <p>{profileDetails.coachName}</p>
                                                                            </li>
                                                                            <li>
                                                                                <h6>State Name:</h6>
                                                                                <p>{profileDetails.geographyName}</p>
                                                                            </li>
                                                                            <li>
                                                                                <h6>District Name:</h6>
                                                                                <p>{profileDetails.geoDistrictsName}</p>
                                                                            </li>
                                                                        </ul>
                                                                        </div>
                      <div className="appointment-info appoin-border double-row">
                                                                        <ul className="appointmentset">
                                                                            <li>
                                                                                <h6>City Name:</h6>
                                                                                <p>{profileDetails.geoCityName}</p>
                                                                            </li>
                                                                            <li>
                                                                                <h6>Center Name:</h6>
                                                                                <p>{profileDetails.geoCenterName}</p>
                                                                            </li>
                                                                            <li>
                                                                                <h6>Athelete Onboard Status Name:</h6>
                                                                                <p>{profileDetails.athleteOnboardStatusName}</p>
                                                                            </li>
                                                                            <li>
                                                                                <h6>Status:</h6>
                                                                                <p>{(profileDetails.userStatus == 1) ? "Active" : "Inactive"}</p>
                                                                            </li>
                                                                            {/* <td><h6>{(profileDetails.userStatus == 1) ? "Active" : "Inactive"}</h6></td> */}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                                {/* </div> */}
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div
                                                            className="file-upload-text"
                                                            style={{
                                                                position: "relative",
                                                                width: "100%"
                                                            }}
                                                        >
                                                            <div className="file-upload">
                                                                {selectedImage ? (
                                                                    <>
                                                                        {/* Cropper */}
                                                                        <div
                                                                            style={{
                                                                                position: "relative",
                                                                                width: "100%",
                                                                                height: "100px",
                                                                                background: "#f5f5f5",
                                                                                overflow: "hidden"
                                                                            }}
                                                                        >
                                                                            <Cropper
                                                                                image={selectedImage}
                                                                                crop={crop}
                                                                                zoom={zoom}
                                                                                aspect={1}
                                                                                cropShape="rect"
                                                                                showGrid={true}
                                                                                onCropChange={setCrop}
                                                                                onZoomChange={setZoom}
                                                                                onCropComplete={onCropComplete}
                                                                            />
                                                                        </div>

                                                                        {/* Zoom */}
                                                                        <div
                                                                            style={{
                                                                                width: "100%",
                                                                                padding: "15px"
                                                                            }}
                                                                        >
                                                                            <label className="form-label">
                                                                                Zoom
                                                                            </label>

                                                                            <input
                                                                                type="range"
                                                                                min={1}
                                                                                max={3}
                                                                                step={0.1}
                                                                                value={zoom}
                                                                                onChange={(e) =>
                                                                                    setZoom(Number(e.target.value))
                                                                                }
                                                                                style={{
                                                                                    width: "100%"
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        {/* Save button */}
                                                                        <div
                                                                            style={{
                                                                                width: "100%",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                marginTop: "10px"
                                                                            }}
                                                                        >
                                                                            <Button
                                                                                type="button"
                                                                                variant="success"
                                                                                className="btn-primary text-uppercase"
                                                                                onClick={handleCropSave}
                                                                            >
                                                                                <i className="fas fa-save" />&nbsp;
                                                                                Save
                                                                            </Button>
                                                                        </div>
                                                                    </>
                                                                ) : imagePreview ? (
                                                                    <>
                                                                        {/* Existing profile image */}
                                                                        <img
                                                                            src={imagePreview}
                                                                            className="img-fluid"
                                                                            alt="Profile Preview"
                                                                            style={{
                                                                                width: "100px",
                                                                                height: "100px",
                                                                                objectFit: "cover"
                                                                            }}
                                                                        />

                                                                        {/* Change image */}
                                                                        <span>
                                                                            <i className="feather-edit-3" />
                                                                            <input
                                                                                type="file"
                                                                                id="file-input"
                                                                                accept="image/jpeg,image/png,image/svg+xml"
                                                                                onChange={handleImageSelect}
                                                                            />
                                                                        </span>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <ImageWithBasePath
                                                                            src="assets/img/icons/img-icon.svg"
                                                                            className="img-fluid"
                                                                            alt="Upload"
                                                                        />
                                                                        <p>Upload Photo</p>
                                                                        <span>
                                                                            <i className="feather-edit-3" />
                                                                            <input
                                                                                type="file"
                                                                                id="file-input"
                                                                                accept="image/jpeg,image/png,image/svg+xml"
                                                                                onChange={handleImageSelect}
                                                                            />
                                                                        </span>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card card-tableset">
                                            <div className="card-body">
                                                <div className="row align-items-center" style={{ maxHeight: "280px", overflowY: "scroll" }}>
                                                    <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                                        <div className="coach-court-list">
                                                            <ul className="nav">
                                                                {tabData.map((tab, i) => (
                                                                    <li key={i}>
                                                                        <Link
                                                                            to="#"
                                                                            className={tab.name === activeTab ? "active" : ""}
                                                                            onClick={() => setActiveTab(tab.name)}
                                                                        >
                                                                            {tab.icon} {tab.name}
                                                                        </Link>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className="tab-content">
                                                        {tabData
                                                            .filter(tab => tab.name === activeTab)
                                                            .map((tab, i) => (
                                                                <div key={i}>{tab.content}</div>
                                                            ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >

            <Modal
                show={openModal}
                size="md"
                centered
                onHide={() => setOpenModal(false)}>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="text-uppercase text-center"><i className="fas fa-key" />Change Password</h4>
                    </ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="col-lg-12 mb-10">
                        <label className="form-label">Current Password</label>
                        <input
                            type="password"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            id="crntPwd"
                            value={oldPwd}
                            onChange={(e) => setOldPwd(e.target.value)}
                            placeholder="Current Password"
                        />
                    </div>
                    <div className="col-lg-12 mb-10">
                        <label className="form-label">New Password</label>
                        <input
                            type="password"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            id="newPwd"
                            value={newPwd}
                            onChange={(e) => setNewPwd(e.target.value)}
                            placeholder="New Password"
                        />
                    </div>
                    <div className="col-lg-12 mb-10">
                        <label className="form-label">Confirm Password</label>
                        <input
                            type="password"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            id="cnfmPwd"
                            value={cnfmNwPwd}
                            onChange={(e) => { setCnfmNwPwd(e.target.value); validatePasswords(newPwd, e.target.value) }}
                            placeholder="Confirm Password"
                        />
                    </div>

                    {pwdError && <div className="alert alert-danger">{pwdError}</div>}

                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-primary text-uppercase"
                        variant="success"
                        // onClick={changePwd}
                        data-bs-dismiss="modal" aria-label="Close"
                    >
                        <b><i className="fas fa-save" /> Save</b>
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default Profile;